const PowerSaving = ({ size = 20, color = 'rgb(135, 135, 135)' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    {/* 閃電符號 */}
    <path
      d="M7 2L3 10H7L4 18L12 8H8L11 2H7Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* $ 符號 */}
    <text
      x="17"
      y="15.6"
      textAnchor="middle"
      fontSize="12"
      fontFamily="Arial, sans-serif"
      fill={color}>
      $
    </text>
  </svg>
)

export default PowerSaving
